// extracted by mini-css-extract-plugin
export default {"borrowSize":"rPpzZ","borrowSize__mainRow":"EPSkl","borrowSize__mainText":"GoTNj","borrowSize__value":"XlfLK","borrowSize__row":"Sdxw4","borrowSize__rowText":"NJmGB"};